<template>
  <input
    class="custom-range"
    :max="max"
    :min="min"
    :name="name"
    :step="step"
    type="range"
    :value="getValue"
    @blur="onBlur"
    @focus="onFocus"
    @input="onInput"
    @keydown.enter="onEnter" />
</template>

<script>
import { FormElement } from '@/mixins'

export default {
  name: 'BaseRange',

  mixins: [FormElement],

  props: {
    currency: Boolean,
    max: String,
    min: String,
    step: {
      default: '1',
      type: String
    },
    value: [Number, String]
  }
}
</script>
